<template>
	<div class="filters" :class="{ 'filters--loading' : loading }">
		<div class="product__addon-desc" :class="{ 'product__addon-desc--open' : attributesExplanationsSidebar }">
			<span class="product__addon-close" @click="closeExplanationSidebar()"></span>
			<div v-for="attrExpl in attributesExplanations" :key="attrExpl.id">
				<div class="product__addon-desc-inner editor" v-if="attrExpl.visible"  v-html="attrExpl.content"></div>
			</div>
		</div>
		<div :class="{ 'products__loader--loading' : loading }" class="products__loader filters__loader">
			<img v-bind:src="loaderSvgUrl" />
		</div>
		<div class="filter" v-for="filter in sideFilters" :style="{ order: filter.order }">
			<div class="filter__title-container" :class="{ 'filter__title-container--open' : filter.open == true }">
				<div class="filter__title" @click="toggleFilterBlock(filter.id)" v-html="filter.name"></div>
				<div class="filter__expl" v-if="showExplLink(filter.id)" @click="showExplanation(filter.id)">Uitleg</div>
			</div>
			<ul v-if="filter.type === 'radio' || filter.type === 'checkbox'" class="filter__items" :class="{ 'filter__items--open' : filter.open == true }">
				<li class="filter__item" v-for="item in filter.data" :key="item.id">
					<div class="filter__checkbox-container">
						<label class="filter__checkbox">
							<!-- Radio -->
							<input v-if="filter.type == 'radio'" :id="item.id" :name="filter.slug" :type="filter.type" :value="item.id" v-model="filter.checked" @change="generateUrlParameters()">
							<!-- Checkobx -->
							<input v-if="filter.type == 'checkbox'" :id="item.id" :name="filter.slug" :type="filter.type" :value="item.id" v-model="item.checked" @change="generateUrlParameters()">
							<span class="filter__checker"></span>
							<p class="filter__checkbox-label" v-html="filterItemHTML(item.slug, item.name, '-')"></p>
						</label>
					</div>
				</li>
			</ul>
            <div v-if="filter.type === 'range'" class="filter__range">
                <span v-if="language !== 'en'">&euro;</span>
                <span v-if="language === 'en'">&pound;</span>
                <input type="number" step="100" v-on:keyup.enter="generateUrlParameters()" @blur="generateUrlParameters()" v-model="filter.min">
                <span v-text="filter.sepLabel"></span>
                <input type="number" step="100" v-on:keyup.enter="generateUrlParameters()" @blur="generateUrlParameters()" v-model="filter.max">
            </div>
		</div>
	</div>
</template>

<script>

import axios from 'axios';
import setLanguage from './mixins/setLanguage';
import determineLanguage from './mixins/determineLanguage';
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";
import EventBus from './mixins/eventBus';

export default {
	data() {
		return {
			sideFilters: {},
			attributesExplanationsSidebar: false,
			attributesExplanations: {},
			api: null,
			language: '',
			loading: true,
            loaderBase: window.location.origin,
			baseUrl: String,
			urlParamaters: [],
            loaderSvgUrl: null
		}
	},
	mixins: [setLanguage, determineLanguage],
	props: {

	},
	mounted() {
		this.setBaseUrl();
		this.language = this.setLanguage();
		this.setApi();
		this.getAttributes();
        this.priceRangeFilter();
        this.getLoaderSvg();

		EventBus.$on('UPDATE_PRODUCTS_BY_PAGINATION', pageNumber => {
			this.generateUrlParameters(false, pageNumber);
		});
	},
	methods: {
        priceRangeFilter() {
            let _this = this;
            let filterName = _this.determineLanguage({nl: 'Prijs', en: 'Price', de:'Preice'});
            let separatorLabel = _this.determineLanguage({nl: 'tot', en: 'till', de:'bis'});

            let filterObject = {
                id: 0,
                name: filterName,
                slug: 'price_range',
                type: 'range',
                open: true,
                min: 0,
                max: 20000,
                sepLabel: separatorLabel
            }

            this.sideFilters[0] = filterObject;
        },
		setApi() {
            let _this = this;
            let defUrl = window.location.origin;

            if (window.location.origin.includes('test')) {
                defUrl = window.location.origin + '/' + _this.language;
            }

			const api = new WooCommerceRestApi({
				url: defUrl,
				consumerKey: "ck_bc12769287d852897fab480d22fa72364ab663bf",
				consumerSecret: "cs_2526a65fcc0406444549a22c66e128912a652a68",
				version: "wc/v3",
                queryStringAuth: true
			});
			this.api = api
		},
		getAttributes() {
			let _this = this;
			let api = this.api;
			let toFetchAttributes = [1,4,9,13,10]; // ID's from attributes to fetch
			let termsFetchCounter = 1;

            if (_this.language === 'de') {
                toFetchAttributes = [15,21,16,20];
            }

            if (_this.language == 'en') {
                toFetchAttributes = [20,15,17,19,18,22];
            }


			// 1. Fetch all attributes (these do not container the terms)
			api.get("products/attributes", {
				'lang': this.language,
                'consumer_key': 'ck_bc12769287d852897fab480d22fa72364ab663bf',
                'consumer_secret': 'cs_2526a65fcc0406444549a22c66e128912a652a68'
			})
			.then((response) => {
				// Successful request
				let responseLength = response.data.length;

                for (var i = 0; i < response.data.length; i++) {
					if (toFetchAttributes.includes(response.data[i].id)) {

						// Set filterblock type (radio, checkbox, etc.)
                        let radios = ['pa_bouwsysteem', 'pa_houtsoort', 'pa_konstruktionssystem', 'pa_holzarten', 'pa_construction-system', 'pa_wood-types'];
						let filterType = 'checkbox';
						// filterType = (radios.includes(response.data[i].slug)) ? 'radio' : 'checkbox';

						let order = this.setFilterOrder(response.data[i].slug);

						// Create filterObject
						let filterObject = {
							id: response.data[i].id,
							name: response.data[i].name,
							slug: response.data[i].slug,
							type: filterType,
							order: order,
							checked: 0,
							open: true,
							data: []
						}

						let fetchString = 'products/attributes/' + response.data[i].id + '/terms';

                        // 2. Fetch all terms belonging to this attribute
                        api.get(fetchString, {
                            'lang': this.language,
                            'consumer_key': 'ck_bc12769287d852897fab480d22fa72364ab663bf',
                            'consumer_secret': 'cs_2526a65fcc0406444549a22c66e128912a652a68'
                        })
						.then((response) => {
							// Successful request
							for (let item = 0; item < response.data.length; item++) {
								response.data[item]['checked'] = false;
							}

							filterObject.data = response.data;

							// Set loading to false after last filter block
							if (termsFetchCounter == toFetchAttributes.length || termsFetchCounter == (toFetchAttributes.length - 1)) {
								_this.loading = false;

								_this.fillByPageLoadParameters();
							}
							termsFetchCounter++;
						})
						.catch((error) => {
							// Invalid request, for 4xx and 5xx statuses
							console.log('fetch terms error', error);
						});


						_this.sideFilters[response.data[i].id] = filterObject;

					}
				}
			})
			.catch((error) => {
				// Invalid request, for 4xx and 5xx statuses
				console.log("Response Status:", error.response.status);
				console.log("Response Headers:", error.response.headers);
				console.log("Response Data:", error.response.data);
			})
			.finally(() => {
				// Always executed.
				// Update attributes count for the first time on page load after all filters are loaded
				EventBus.$emit('PAGE_LOAD_ATTR_COUNT');
			});

			let getAttributesDescriptions = function getAttributesDescriptions() {
				// /wp-json/attributes_expl/v1/attr
				let defUrl = window.location.origin + '/wp-json/attributes_expl/v1/attr';
				return axios.get(defUrl)
				.then(response => {
					// JSON responses are automatically parsed.
					let attrArr = [];

					for (const attr in response.data) {

						let attrObj = {
							id: attr,
							content: response.data[attr],
							visible: false
						}

						attrArr.push(attrObj);
					}

					_this.attributesExplanations = attrArr;
				});
			};

			// Toepassingen
			let productApplications = function productApplications() {
				// Load items from taxonomy 'product_cat'

                let filterName = _this.determineLanguage({nl: 'Toepassing', en: 'Application', de:'Anwendung'});

				let defUrl = window.location.origin + '/wp-json/wp/v2/toepassing_cat_product?per_page=100';

                // Different 'defUrl' for local environment (multisite - subfolder)
                if (window.location.origin.includes('test')) {
                    defUrl = window.location.origin + '/' + _this.language + '/wp-json/wp/v2/toepassing_cat_product?per_page=100';
                }

				return axios.get(defUrl)
				.then(response => {
					// JSON responses are automatically parsed.

					let filterObject = {
						id: 90,
						name: filterName,
						slug: 'toepassing_cat_product',
						type: 'checkbox',
						order: 1,
						checked: 0,
						open: true,
						data: response.data
					}

					_this.sideFilters[90] = filterObject;
				});
			};

			Promise.all([productApplications(), getAttributesDescriptions()]).then(function (v) {

			}).catch(function (e) {
				console.error('Promise all error', e);
			});

		},
		setBaseUrl() {
			this.baseUrl = window.location.origin;
		},
		showExplLink(id) {
			let _this = this;
			let returnBool = false;
			for (const explId in _this.attributesExplanations) {
				let attrId = parseInt(_this.attributesExplanations[explId].id);

				if (id == attrId) {
					returnBool = true;
				}
			}

			return returnBool;
		},
		showExplanation(id) {
			let _this = this;
			for (const explId in _this.attributesExplanations) {
				_this.attributesExplanations[explId].visible = false
				let attrId = parseInt(_this.attributesExplanations[explId].id);

				if (id == attrId) {
					_this.attributesExplanationsSidebar = true;
					_this.attributesExplanations[explId].visible = true;
				}
			}
		},
		closeExplanationSidebar() {
			this.attributesExplanationsSidebar = false;
		},
		filterItemHTML(slug, name, count) {
			let html = name;
			html += '<span data-slug="' + slug + '">(' + count + ')</span>';
			return html;
		},
		generateUrlParameters(event, pageNumber = 1) {
			let _this = this;
			this.$forceUpdate();

			this.urlParamaters = [];

			if (event) {
				event.preventDefault();
			}

			let allSideFilters = this.sideFilters;
			for (const filterObject in allSideFilters) {
				// Send single value to createParameter if type = radio
				if (allSideFilters[filterObject]['type'] === 'radio') {
					let filterSlug = allSideFilters[filterObject]['slug'];
					let filterValue = allSideFilters[filterObject]['checked'];
					if (filterValue !== 0) {
						_this.urlParamaters.push(_this.createParameter(filterSlug, filterValue));
					}
				}

				// Send array with single of multiple values to createParameter if type = checkbox
				if (allSideFilters[filterObject]['type'] === 'checkbox') {
					let checkedIds = []
					let filterSlug = allSideFilters[filterObject]['slug'];
					let filterInputs = allSideFilters[filterObject]['data'];
					for (const filterItem in filterInputs) {
						if (filterInputs[filterItem]['checked']) {
							checkedIds.push(filterInputs[filterItem]['id']);
						}
					}
					if (checkedIds.length > 0) {
						_this.urlParamaters.push(_this.createParameter(filterSlug, checkedIds));
					}
				}

                if (allSideFilters[filterObject]['type'] === 'range') {
                    let checkedIds = []
                    let filterSlug = allSideFilters[filterObject]['slug'];
                    checkedIds.push(allSideFilters[filterObject]['min']);
                    checkedIds.push(allSideFilters[filterObject]['max']);
                    _this.urlParamaters.push(_this.createParameter(filterSlug, checkedIds));
                }
			}

            // Add page parameter if is not 1
            if (pageNumber !== 1) {
                _this.urlParamaters.push('&page=' + pageNumber);
            }

			// Combine all parameters to 1 string
			let urlParametersString = '';
			if (this.urlParamaters.length > 0) {
				for (const param in this.urlParamaters) {
					urlParametersString += this.urlParamaters[param];
				}
			}

			// Set parameters in address bar
            if (urlParametersString.length > 0) {
                window.location.hash = '#!/' + urlParametersString;
            } else {
                window.location.hash = '';
                window.history.replaceState({}, '', window.location.href.slice(0, -1));
            }

			if (urlParametersString) {
				EventBus.$emit('UPDATE_PRODUCTS', {filterParameters: urlParametersString, page: pageNumber});
			} else {
				EventBus.$emit('UPDATE_PRODUCTS', {filterParameters: null, page: 1});
			}
		},
        createParameter(base, value) {
            let encodedBase = encodeURIComponent(base);

            if (typeof value == 'number') {
                let param = '&' + encodedBase + '=' + value;
                return param;
            }
            if (typeof value == 'object') {
                let param = '&' + encodedBase + '=';

                for (let i = 0; i < value.length; i++) {
                    // If is not last item then add comma
                    let item = value[i];

                    // Adjust string to by compatible in url
                    if (typeof item == 'string') {
                        item = encodeURIComponent(item);
                    }

                    let cur = i + 1;
                    if (cur !== value.length) {
                        param += item;
                        param += ',';
                    } else {
                        param += item;
                    }
                }
                return param;
            }
        },
		setFilterOrder(slug) {
			switch(slug) {
  		  		case 'pa_bouwsysteem':
                case 'pa_konstruktionssystem':
                case 'pa_construction-system':
					return 2;
					break;
				case 'pa_houtsoort':
                case 'pa_holzarten':
                case 'pa_wood-types':
					return 91;
					break;
				case 'pa_breedte':
                case 'pa_breite':
                case 'pa_width':
					return 90;
					break;
				case 'pa_diepte':
                case 'pa_tiefe':
                case 'pa_depth':
					return 92;
					break;
				case 'pa_daktype':
                case 'pa_dachtyp':
                case 'pa_rooftype':
					return 3;
					break;
				case 'pa_wanddikte':
                case 'pa_wandstarke':
                case 'pa_wall-thickness':
					return 93;
					break;
				case 'pa_merk':
                case 'pa_marke':
                case 'pa_brand':
					return 94;
					break;
                default:
					return 99;
				}
		},

		fillByPageLoadParameters() {
			let _this = this;
			if (window.location.hash && window.location.hash.includes('#!/&')) {
				// Get URL parameters
				let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', ''));
				onLoadParameters = onLoadParameters.substring(1);

				// Create object from parameters
				let parametersObject = JSON.parse('{"' + decodeURI(onLoadParameters).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

				// Loop throug object and set Vue data values
				if (typeof parametersObject === 'object' && parametersObject !== null) {
					for (const [key, value] of Object.entries(parametersObject)) {
						// Project filters
						// As mentioned above no need to manually set/check/select html elements, vue binding does that for us.

						// Array with all filters
						let filtersObject = [];

						// Loop through filters to create a complete array with all filters
						for (const filter in _this.sideFilters) {
							filtersObject.push(_this.sideFilters[filter])
						}

						for (var fKey in filtersObject) {

							let type = filtersObject[fKey]['type'];
							let slug = filtersObject[fKey]['slug'];
							let paramSlug = key;

							if (slug === paramSlug) {
								// check every type so value will be filled correctly
								if (type === 'select') {
									filtersObject[fKey]['checked'] = parseInt(value);
								} else if (type === 'checkbox' || type === 'radio') {

									//Convert string with multiple values to array
									let valArray = value.split(',');

									//Convert array values to integers
									valArray = valArray.map((i) => Number(i));

									//Loop through all checkboxes and set checked if value exists in valArray
									let filterItems = filtersObject[fKey].data;

									for (var iKey in filterItems) {
										if (valArray.includes(filterItems[iKey]['id'])) {
											filterItems[iKey]['checked'] = true;
										}
									}
								}

								// Not sure yet if necessary
								if (type === 'radio') {
									filtersObject[fKey]['checked'] = parseInt(value);
								}

                                if (type === 'range') {
                                    let arrayWithRange = value.split(",");
                                    if (arrayWithRange.length > 1) {
                                        filtersObject[fKey]['min'] = arrayWithRange[0];
                                        filtersObject[fKey]['max'] = arrayWithRange[1];
                                    }
                                }
							}
						}
					}
				} else {
					console.warn('URL parameters are not an object');
				}
			}
		},
		toggleFilterBlock(id) {
			if (id) {
				this.sideFilters[id].open = !this.sideFilters[id].open;
				this.$forceUpdate();
			}
		},
        getLoaderSvg() {
            let loaderPath = '/wp-content/themes/woodpro/src/svg/loader.svg';

            if(window.location.origin.includes('woodpro.dev')) {
                loaderPath = '/app/themes/woodpro/src/svg/loader.svg';
            }

            this.loaderSvgUrl = this.baseUrl + loaderPath;
        }
	}
}
</script>
